export default {
  APP_ENV: process.env.NODE_ENV,
  API_URL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_DEVELOPMENT_API_URL,
  SOCIALITE_REDIRECT: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_SOCIALITE_REDIRECT : process.env.REACT_APP_SOCIALITE_REDIRECT,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN
};
